// // Base configuration for content
// const baseContent = {
//   type: "input",
//   inputType: "text",
//   label: "",
//   endTextOfMsg: "",
//   matHint: {
//     flag: false,
//     message: "",
//   },
//   data: {
//     id: "",
//     key: "",
//     value: "",
//     type: "generalSetting",
//     file: {},
//     isUpdated: false,
//   },
//   translation: {
//     id: "",
//     name: "",
//     translationableId: "",
//     translationableType: "Resource",
//     adminId: "",
//     languageId: "",
//     flag: true,
//     isUpdated: false,
//   },
// };

// // Factory function to create a message entry
// const createMessageEntry = (
//   title: string,
//   key: string,
//   label: string,
//   isRequired: boolean = true,
//   readonly: boolean = false,
//   endTextOfMsg: string = "",
//   matHint: { flag: boolean; message: string } = { flag: false, message: "" }
// ) => ({
//   title,
//   content: {
//     ...baseContent,
//     label,
//     endTextOfMsg,
//     matHint,
//     data: {
//       ...baseContent.data,
//       key,
//     },
//     translation: {
//       ...baseContent.translation,
//     },
//   },
//   isRequired,
//   readonly,
//   isButton: false,
// });

// // Array of message entries
// const messages = [
//     { title: "New Game Message", key: "newGameMsg", label: "Please Enter Game Message" },
//     { title: "Winner Message", key: "winnerMsg", label: "Please Enter Winner Message" },
//     { title: "Tiebreaker Message", key: "tiebreakerMsg", label: "Please Enter Tiebreaker Message" },
//     { title: "Loser Message", key: "loserMsg", label: "Please Enter Loser Message" },
//     { title: "Leaderboard Message", key: "leaderboardMsg", label: "Please Enter Leaderboard Message" },
//     { title: "Avatar Points Message", key: "avatarPointsMessage", label: "Please Enter Avatar Points Message", isRequired: false, readonly: true, endTextOfMsg: "activate avatar" },
//     { title: "Activate Auto Match Message", key: "activatingAutoMatchPointsMessage", label: "Please Enter Activate Auto Match Message", isRequired: false, readonly: true, endTextOfMsg: "activate auto match" },
//     { title: "Activate Shareable Content Message", key: "addingShareableContentPointsMessage", label: "Please Enter Activate Shareable Content Message", isRequired: false, readonly: true, endTextOfMsg: "activate shareable content" },
//     { title: "Activate Manual Advertisement Message", key: "addingManualAdvertisementPointsMessage", label: "Please Enter Activate Manual Advertisement Message", isRequired: false, readonly: true, endTextOfMsg: "activate manual advertisement" },
//     { title: "Automatic Message", key: "automaticMessage", label: "Please Enter Automatic Message", isRequired: false, matHint: { flag: true, message: "Congratulations USER NAME, How would you like to receive your PRIZE NAME, USERNAME and PRIZE NAME are reserved words" } },
//     { title: "Automatic Donation Message", key: "automaticDonationMessage", label: "Please Enter Automatic Donation Message", isRequired: false, matHint: { flag: true, message: "Hi USER NAME, Thank you so much for your donation to ORGANIZATION NAME, USERNAME and ORGANIZATION NAME are reserved words" } },
//     { title: "Prize Confirmation", key: "prizeConfirmationMsg", label: "Please Enter Prize Confirmation Message" },
//     { title: "Donation Thank You", key: "donationThankYouMsg", label: "Please Enter Donation Thank You Message" },
//     { title: "Within Range", key: "withinRangeMsg", label: "Please Enter Within Range Message" },
//     { title: "Out Of Range", key: "outOfRangeMsg", label: "Please Enter Out Of Range Message" },
//     { title: "Thank You For Rating", key: "thankYouRatingMsg", label: "Please Enter Thank You For Rating Message" },
//     { title: "Link Not Accepted", key: "linkNotAcceptedMsg", label: "Please Enter Link Not Accepted Message" },
//     { title: "Play AD Free With Auto Match", key: "playADFreeWithAutoMatch", label: "Please Enter Play AD Free With Auto Match Message" },
//     { title: "LOGIN LIMIT REACHED", key: "loginLimitReached", label: "Please Enter Login Limit Reached" },
//     { title: "SOCIAL LOGIN PROMPT", key: "socialLoginPrompt", label: "Please Enter Social Login Prompt", matHint: { flag: true, message: "LOOKS LIKE YOU ARE ALREADY LOGGED IN WITH SOCIAL LOGIN ON THIS DEVICE, PLEASE CHOOSE ANOTHER LOGIN, SOCIAL LOGIN is a reserved word" } },
// ];

// messages.map(({ title, key, label, isRequired = true, readonly = false, endTextOfMsg = "", matHint = { flag: false, message: "" } }) =>
//   createMessageEntry(title, key, label, isRequired, readonly, endTextOfMsg, matHint)
// );

// export { messages };

// Base configuration for input content
const baseInputContent = {
  type: "input",
  inputType: "text",
  label: "",
  endTextOfMsg: "",
  matHint: {
    flag: false,
    message: "",
  },
  data: {
    id: "",
    key: "",
    value: "",
    type: "generalSetting",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

// Base configuration for image content
const baseImageContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "gameOver",
    file: {},
    languageId: null,
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
    translationableId: "",
  },
};

// Factory function to create an input message entry
const createInputMessageEntry = (
  title: string,
  key: string,
  label: string,
  isRequired: boolean = true,
  readonly: boolean = false,
  endTextOfMsg: string = "",
  matHint: { flag: boolean; message: string } = { flag: false, message: "" }
) => ({
  title,
  content: {
    ...baseInputContent,
    label,
    endTextOfMsg,
    matHint,
    data: {
      ...baseInputContent.data,
      key,
    },
    translation: {
      ...baseInputContent.translation,
    },
  },
  isRequired,
  readonly,
  isButton: false,
});

// Factory function to create an image entry
const createImageEntry = (
  title: string,
  key: string
) => ({
  title,
  content: {
    ...baseImageContent,
    data: {
      ...baseImageContent.data,
      key,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

// Standard message entries
const standardEntries: any = [
  { title: "New Game Message", key: "newGameMsg", label: "Please Enter Game Message" },
  { title: "Winner Message", key: "winnerMsg", label: "Please Enter Winner Message" },
  { title: "Tiebreaker Message", key: "tiebreakerMsg", label: "Please Enter Tiebreaker Message" },
  { title: "Loser Message", key: "loserMsg", label: "Please Enter Loser Message" },
  { title: "Leaderboard Message", key: "leaderboardMsg", label: "Please Enter Leaderboard Message" },
  { title: "Avatar Points Message", key: "avatarPointsMessage", label: "Please Enter Avatar Points Message", isRequired: false, readonly: true, endTextOfMsg: "activate avatar" },
  { title: "Activate Auto Match Message", key: "activatingAutoMatchPointsMessage", label: "Please Enter Activate Auto Match Message", isRequired: false, readonly: true, endTextOfMsg: "activate auto match" },
  { title: "Activate Shareable Content Message", key: "addingShareableContentPointsMessage", label: "Please Enter Activate Shareable Content Message", isRequired: false, readonly: true, endTextOfMsg: "activate shareable content" },
  { title: "Activate Manual Advertisement Message", key: "addingManualAdvertisementPointsMessage", label: "Please Enter Activate Manual Advertisement Message", isRequired: false, readonly: true, endTextOfMsg: "activate manual advertisement" },
  { title: "Automatic Message", key: "automaticMessage", label: "Please Enter Automatic Message", isRequired: false, matHint: { flag: true, message: "Congratulations USER NAME, How would you like to receive your PRIZE NAME, USERNAME and PRIZE NAME are reserved words" } },
  { title: "Automatic Donation Message", key: "automaticDonationMessage", label: "Please Enter Automatic Donation Message", isRequired: false, matHint: { flag: true, message: "Hi USER NAME, Thank you so much for your donation to ORGANIZATION NAME, USERNAME and ORGANIZATION NAME are reserved words" } },
  { title: "Prize Confirmation", key: "prizeConfirmationMsg", label: "Please Enter Prize Confirmation Message" },
  { title: "Donation Thank You", key: "donationThankYouMsg", label: "Please Enter Donation Thank You Message" },
  { title: "Within Range", key: "withinRangeMsg", label: "Please Enter Within Range Message" },
  { title: "Out Of Range", key: "outOfRangeMsg", label: "Please Enter Out Of Range Message" },
  { title: "Thank You For Rating", key: "thankYouRatingMsg", label: "Please Enter Thank You For Rating Message" },
  { title: "Link Not Accepted", key: "linkNotAcceptedMsg", label: "Please Enter Link Not Accepted Message" },
  // { title: "Play AD Free", key: "playADFree", label: "Please Enter Play AD Free" },
  // { title: "With", key: "with", label: `Please Enter "With" translation` },
  // { title: "Auto Match", key: "autoMatchTranslation", label: "Please Enter Auto Match translation" },
  { title: "Automatch Button Description", key: "playADFreeWithAutoMatch", label: "Please Enter Automatch Button Description" },
  { title: "LOGIN LIMIT REACHED", key: "loginLimitReached", label: "Please Enter Login Limit Reached" },
  { title: "SOCIAL LOGIN PROMPT", key: "socialLoginPrompt", label: "Please Enter Social Login Prompt", matHint: { flag: true, message: "LOOKS LIKE YOU ARE ALREADY LOGGED IN WITH SOCIAL LOGIN ON THIS DEVICE, PLEASE CHOOSE ANOTHER LOGIN, SOCIAL LOGIN is a reserved word" } },
].map(({ title, key, label, isRequired = true, readonly = false, endTextOfMsg = "", matHint = { flag: false, message: "" } }) =>
  createInputMessageEntry(title, key, label, isRequired, readonly, endTextOfMsg, matHint)
);

// New image entries
const newImageEntries = [
  { title: "ENTER TO WIN IMAGE", key: "enterToWinImage" },
  { title: "OR ENTER TO WIN IMAGE", key: "orEnterToWinImage" },
  // Add more image entries as needed
].map(({ title, key }) => createImageEntry(title, key));

// Combine all entries
const messages = standardEntries.concat(newImageEntries);

export { messages };
